<template>
  <div class="Editor-Gif-Module">
    <button class="Editor-Gif-Module__icon" @click="toToggle" ref="toggleBtn">
      <GifIcon />
    </button>
    <transition name="Anim__fadeUp">
      <div class="Editor-Gif-Module__dropdown" v-if="isOpen" ref="dropdownGif">
        <div class="Editor-Gif-Module__input-box">
          <SearchIcon class="Editor-Gif-Module__search-icon" :class="get_focusClass" />
          <input 
            class="Editor-Gif-Module__input" 
            placeholder="Поиск" 
            v-model="searchQuery" 
            @input="onInput" 
            @focus="toToggleFocus(true)" 
            @blur="toToggleFocus(false)" 
            ref="inputField"
          />
        </div>
        <div class="Editor-Gif-Module__output">
          <div class="Editor-Gif-Module__list" v-if="!isLoading">
            <li class="Editor-Gif-Module__item" v-for="image in output">
              <img class="Editor-Gif-Module__image" :src="image.media_formats.gif.url" @click="toChooseImage"/>
            </li>
            <li class="Editor-Gif-Module__empty" v-if="get_isEmpty">По данному запросу ничего не найдено</li>
          </div>
          <div class="Editor-Gif-Module__loader" v-if="isLoading">
            <LoaderCircle  :size="28" :color="'var(--blue-600)'"/>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { computed, ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
  import { searchGifs, getTrendingGifs } from './api/tenorApi.js';
  import { debounce } from 'lodash';
  //---------------------------------
  import GifIcon from '@svg/GifIcon.vue';
  import SearchIcon from '@svg/SearchIcon.vue';
  import LoaderCircle from '@ui/Loaders/LoaderCircle/LoaderCircle.vue';
  //---------------------------------
  const emit = defineEmits();
  //---------------------------------
  const isOpen = ref(false);
  const isFocus = ref(false);
  const isLoading = ref(false);
  const output = ref([]);
  const searchQuery = ref('');
  const dropdownGif = ref(null);
  const toggleBtn = ref(null);
  const inputField = ref(null);
  //---------------------------------
  onMounted(async () => {
    toGetTrendingGifs();
    document.addEventListener('click', handleClickOutside);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });
  //---------------------------------
  //Применить класс модификатор фокуса
  const get_focusClass = computed(() => isFocus.value ? 'Editor-Gif-Module__search-icon--focus' : '');
  //Результат поиска пустой?
  const get_isEmpty = computed(() => output.value.length === 0);
  //---------------------------------
  //Дебаунс функция поиска
  const debouncedSearch = debounce(async () => {
    if (!searchQuery.value.trim()) {
      toGetTrendingGifs();
      return;
    }
    try {
      output.value = await searchGifs(searchQuery.value);
    } catch (error) {
      console.error('Ошибка при поиске GIF:', error);
    } finally {
      isLoading.value = false;
    }
  }, 600); 
  //Вызывается при вводе текста
  const onInput = () => {
    isLoading.value = true;
    debouncedSearch();
  }
  //Получить трендовые гифки
  const toGetTrendingGifs = async () => {
    try{
      isLoading.value = true;
      output.value = await getTrendingGifs();
    }catch(error){
      console.error('Ошибка при поиске GIF:', error);
    }finally{
      isLoading.value = false;
    }
  }
  //Выбрать картинку и передать ее на выход
  const toChooseImage = (e) => {
    emit('image', e.target.src);
  }
  //Открытие/закрытие дропдауна
  const toToggle = async() => {
    isOpen.value = !isOpen.value;
    await nextTick();
    if(isOpen.value) inputField.value.focus();
  }
  //Проверка, был ли клик вне доступной области
  const handleClickOutside = (e) => {
    if (dropdownGif.value && !dropdownGif.value.contains(e.target) && !toggleBtn.value.contains(e.target)) {
      isOpen.value = false;
    }
  };
  //Переключить фокус
  const toToggleFocus = (status) => isFocus.value = status;
</script>

<style lang="scss">
  @import './styles/_styles';
</style>